import { AreaHasEquipmentModel } from "./AreaHasEquipment.model";

export class AreaHasEquipment extends AreaHasEquipmentModel {
    // Add custom methods here
}
